// Full-page candidate only. First parser script; owns only the marked native form.
// Theme/app scripts remain present. No global SC setting or network API is changed.
(function install(global){
 const doc=global.document,script=doc.currentScript;
 const installedFirstScript=!!script&&doc.scripts[0]===script;
 if(!installedFirstScript||global.PTE09Capture)return;
 const originalAdd=global.EventTarget.prototype.addEventListener;
 const originalRemove=global.EventTarget.prototype.removeEventListener;
 const registrations=[];let binding=null,auditedForm=null,probe=false,sentinelCalls=0;
 const marked=form=>form?.matches?.('form[data-pt-e09-form="true"]');
 const owned=form=>form===auditedForm||marked(form);
 const relevant=target=>auditedForm&&(target===global||target===doc||target===auditedForm||target?.contains?.(auditedForm));
 const audit=()=>{
  const form=auditedForm;
  const path=form?[form,...(function*(n){while(n){yield n;n=n.parentElement}})(form.parentElement),doc,global]:[];
  const foreign=registrations.filter(r=>relevant(r.target));
  const inline=path.some(n=>['onsubmit','onformdata','onclick','onkeydown'].some(k=>typeof n[k]==='function'));
  const forms=Array.from(doc.querySelectorAll('form[data-pt-e09-form="true"]'));
  const result={transport_registration_policy:'owned_events_stopped_at_first_window_capture',registration_count_basis:'observed_add_calls_not_active_handlers',version:'e09-full-page-v1',first_script:installedFirstScript,installed_first_script:installedFirstScript,current_script_index:Array.from(doc.scripts).indexOf(script),capture_script_connected:script.isConnected===true,marked_form_count:forms.length,connected:!!form?.isConnected,foreign_transport_registrations:foreign.length,inline_transport_handlers:inline,sentinel_calls:sentinelCalls,scripts:Array.from(doc.scripts).map(s=>({src:s.src||'',type:s.type||'classic'}))};
  return {...result,ok:result.first_script&&result.capture_script_connected&&forms.length===1&&forms[0]===form&&result.connected&&!inline&&sentinelCalls===0};
 };
 global.EventTarget.prototype.addEventListener=function(type,callback,options){
  // Later submit/formdata registrations are diagnostic observations, not proof
  // that they can intercept the owned form. First-window capture below stops
  // every owned event before downstream handlers; other forms remain untouched.
  // Count records add calls (including removed/duplicate registrations), not live handlers.
  if(['submit','formdata'].includes(type))registrations.push({target:this,type,callback});
  return originalAdd.call(this,type,callback,options);
 };
 function submit(event){
  if(!owned(event.target))return;
  const intercepted=event.defaultPrevented;
  event.stopImmediatePropagation();
  // Even before renderer/module initialization, never fall through to SC/native add.
  if(!binding||event.target!==binding.form){event.preventDefault();return}
  if(intercepted||!audit().ok){event.preventDefault();binding.onBlocked(intercepted?'submit_already_intercepted':'full_page_capture_audit_failed');return}
  if(probe)event.preventDefault();
  binding.onSubmit(event,{probe,audit:audit()});
 }
 function intent(event){
  const button=event.target?.closest?.('[data-pt-e09-add]');
  const form=button?.form||(auditedForm?.contains(event.target)?auditedForm:event.target?.closest?.('form[data-pt-e09-form="true"]'));
  if(!owned(form)||(!button&&!(event.type==='keydown'&&event.key==='Enter')))return;
  const intercepted=event.defaultPrevented;
  event.stopImmediatePropagation();
  if(!binding||form!==binding.form||intercepted||!audit().ok){event.preventDefault();binding?.onBlocked(intercepted?'intent_already_intercepted':'full_page_capture_audit_failed')}
 }
 function formdata(event){if(owned(event.target))event.stopImmediatePropagation()}
 originalAdd.call(global,'submit',submit,true);
 originalAdd.call(global,'formdata',formdata,true);
 for(const type of ['click','keydown','pointerdown','mousedown','touchstart'])originalAdd.call(global,type,intent,true);
 global.PTE09Capture=Object.freeze({version:'e09-full-page-v1',audit,
  attach(form,onSubmit,onBlocked){
   if(binding||!marked(form))throw Error('one_marked_native_form_only');
   auditedForm=form;binding={form,onSubmit,onBlocked};
   if(!audit().ok){binding=null;throw Error('full_page_capture_audit_failed')}
   return ()=>{binding=null;auditedForm=null};
  },
  probe(){
   if(!binding||probe)throw Error('full_page_form_not_ready');
   const form=binding.form,sentinel=()=>{sentinelCalls++};
   const after=[[global,'submit',true],[form,'submit',true],[form,'submit',false],[global,'formdata',true],[form,'formdata',false]];
   for(const [target,type,capture] of after)originalAdd.call(target,type,sentinel,capture);
   probe=true;
   try{form.requestSubmit()}finally{probe=false;for(const [target,type,capture] of after)originalRemove.call(target,type,sentinel,capture)}
   return audit();
  }
 });
})(window);
